import { render, staticRenderFns } from "./EventCreateDialog.vue?vue&type=template&id=84a96e26&"
import script from "./EventCreateDialog.vue?vue&type=script&lang=js&"
export * from "./EventCreateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports